<select clrSelect name="options" [(ngModel)]="options" (change)="show()">
  <option value="None" [selected]>None</option>
  <option *ngFor="let status of statusOptions" value={{status}}>{{status}}</option>
</select>
